module.exports = __webpack_public_path__ + "img/934.4cc306b4.png";